// extracted by mini-css-extract-plugin
module.exports = {"multiValue":"RoomsWrapper_multiValue__3fakz","highlighted":"RoomsWrapper_highlighted__2wKWa","modal":"RoomsWrapper_modal__2e8pY","property":"RoomsWrapper_property__3ougv"};